export default "__VITE_ASSET__BZ_Y2wWw__"